// extracted by mini-css-extract-plugin
export default {"InputLoader":"InputLoader_InputLoader__1+dXv","spin":"InputLoader_spin__Drij7"};